import React from 'react';

const ErrorLabel = ({ errorMessage }) => {

    return (
        <div className={`col-12 form-group`}>
            <label style={{ color: 'red' }}>
                {errorMessage}
            </label>
        </div>
    );
};

export default ErrorLabel;
